module.exports = __webpack_public_path__ + "static/img/理事長的話.png";